<!-- ── Top: image + stat cards ───────────────────────────────── -->
<div class="gi-top">

    <div class="gi-stat-card gi-car-img">
        <img [src]="carDetails.imageUrl" alt="car"
            (error)="$any($event.target).src='assets/icons/car-placeholder.svg'" />
    </div>

    <button type="button" class="gi-stat-card cursor-pointer" (click)="onRidesCardClick($event)"
        (keydown.enter)="goToRidePage(carDetails.plateNo)">
        <span class="stat-icon">
            <img src="assets/icons/ride-rote-icon.svg" alt="" (error)="$any($event.target).style.display='none'" />
        </span>
        <div class="stat-body align-items-start">
            <span class="stat-label">TOTAL RIDES</span>
            <div class="flex gap-2">
                <span class="stat-value">{{ carDetails.totalRides || '---' }}</span>
                <span class="flex stat-sub align-items-end">Since activation</span>
            </div>
        </div>
    </button>

    <div class="gi-stat-card">
        <span class="stat-icon">
            <img src="assets/icons/BatteryCharging.svg" alt="" (error)="$any($event.target).style.display='none'" />
        </span>
        <div class="stat-body">
            <span class="stat-label">BATTERY</span>
            <div class="stat-bar-row">
                <div class="stat-bar-track">
                    <div class="stat-bar-fill"
                        [style.width]="getBatteryPercentage(telemetry.powerSupplyVoltage) + '%'"
                        [style.background]="getBatteryColor(telemetry.powerSupplyVoltage)">
                    </div>
                </div>
                <span class="stat-value">{{ getBatteryPercentage(telemetry.powerSupplyVoltage) |
                    number:'1.0-0' }}%</span>
            </div>
        </div>
    </div>

    <div class="gi-stat-card">
        <span class="stat-icon">
            <img src="assets/icons/blue-car.svg" alt="" (error)="$any($event.target).style.display='none'" />
        </span>
        <div class="stat-body">
            <span class="stat-label">LAST RIDE</span>
            <span class="stat-value">{{ timeAgo(carDetails.lastRideAt) }}</span>
            <span class="stat-sub">Last activity</span>
        </div>
    </div>

</div>

<!-- ── Middle: live telemetry + chart ───────────────────────── -->
<div class="gi-middle">

    <div class="gi-card">
        <h3 class="gi-card-title">Live Telemetry</h3>

        <div class="fuel-header">
            <span class="fuel-label">FUEL LEVEL</span>
            <span class="fuel-pct">{{ telemetry.fuelLevel || 0 }}%</span>
        </div>
        <div class="fuel-track">
            <div class="fuel-fill" [style.width]="(telemetry.fuelLevel || 0) + '%'"
                [style.background]="getFuelColor(+(telemetry.fuelLevel || 0))">
            </div>
        </div>

        <div class="tele-stats">
            <div class="tele-stat">
                <span class="tele-stat-label">ENGINE STATUS</span>
                <span class="tele-stat-value" [ngClass]="telemetry.engineStatus === 'ON' ? 'text-green': 'text-red'">
                    {{ telemetry.engineStatus || 'Unkown' }}
                </span>
            </div>
            <div class="tele-stat">
                <span class="tele-stat-label">CURRENT SPEED</span>
                <span class="tele-stat-value">{{ telemetry.speed || 0 }} km/h</span>
            </div>
            <div class="tele-stat">
                <span class="tele-stat-label">REMAINING RANGE</span>
                <span class="tele-stat-value">{{ carDetails.remainingRange || 0 }} km/h</span>
            </div>
        </div>
    </div>

    <div class="gi-card gi-chart-placeholder">
        <h3 class="gi-card-title gi-card-title-grey">FUEL — LAST 24H</h3>
        <div class="chart-area">
            @if (fuelChartData()) {
            <p-chart type="line" [data]="fuelChartData()" [options]="fuelChartOptions()" height="100px" width="100%" />
            } @else {
            <span class="chart-hint">Loading…</span>
            }
        </div>
    </div>

</div>

<!-- ── Bottom: vehicle info | telemetry | position ──────────── -->
<div class="gi-bottom">

    <!-- Vehicle Information -->
    <div class="gi-card">
        <h3 class="gi-card-title">Vehicle Information</h3>
        <table class="info-table">
            <tr>
                <td class="info-key">Plate Number</td>
                <td class="info-val">{{ carDetails.plateNo || '---' }}</td>
            </tr>
            <tr>
                <td class="info-key">VIN</td>
                <td class="info-val">{{ carDetails.vin || '---' }}</td>
            </tr>
            <tr>
                <td class="info-key">Body Type</td>
                <td class="info-val">{{ carDetails.model.bodyType || '---' }}</td>
            </tr>
            <tr>
                <td class="info-key">Subaccount</td>
                <td class="info-val">{{ carDetails.model.rentalType.split('_').join(' ') | capitalize }}</td>
            </tr>
            <tr>
                <td class="info-key">Seats</td>
                <td class="info-val">{{ carDetails.model.seats || '---' }}</td>
            </tr>
            <tr>
                <td class="info-key">Horsepower</td>
                <td class="info-val">{{ carDetails.model.horsepower ? (carDetails.model.horsepower + ' hp') :
                    '---' }}</td>
            </tr>
        </table>
    </div>

    <!-- Telemetry Device -->
    <div class="gi-card">
        <h3 class="gi-card-title">Telemetry Device</h3>
        <table class="info-table">
            <tr>
                <td class="info-key">IMEI</td>
                <td class="info-val">
                    <button class="link-btn" (click)="goToManageIOTPage(telemetry.imei!)">
                        {{ telemetry.imei || '---' }}
                    </button>
                </td>
            </tr>
            <tr>
                <td class="info-key">Last signal</td>
                <td class="info-val">
                    {{ telemetry.updatedAt | date:'dd/MM/yyyy' }},
                    {{ telemetry.updatedAt | date:'hh:mm:ssaa' }}
                </td>
            </tr>
            <tr>
                <td class="info-key">Odometer</td>
                <td class="info-val">{{ telemetry.odometer ?  ((telemetry.odometer |
                    number) + ' km') : '---' }}</td>
            </tr>
            <tr>
                <td class="info-key">First ride</td>
                <td class="info-val">
                    {{ carDetails.firstRideAt | date:'dd/MM/yyyy' }},
                    {{ carDetails.firstRideAt | date:'hh:mm:ssaa' }}
                </td>
            </tr>
            <tr>
                <td class="info-key">Last ride</td>
                <td class="info-val">
                    {{ carDetails.lastRideAt | date:'dd/MM/yyyy' }},
                    {{ carDetails.lastRideAt | date:'hh:mm:ssaa' }}
                </td>
            </tr>
            <tr>
                <td class="info-key">IOT dat log</td>
                <td class="info-val">
                    <button class="link-btn" (click)="goToIotDataLogPage(telemetry.imei!)">show</button>
                </td>
            </tr>
        </table>
    </div>

    <!-- Position -->
    <div class="gi-card gi-position-card">
        <h3 class="gi-card-title flex justify-content-between">
            <span class="gi-card-title-grey">POSITION</span>
            <span class="position-coords">
                {{ telemetry.position?.latitude }},
                {{ telemetry.position?.longitude }}
            </span>
        </h3>
        @if (telemetry.position?.latitude) {
        <div class="map-wrap" style="cursor:pointer;" tabindex="0" role="button" (click)="openEndLocationDialog()" (keydown.enter)="openEndLocationDialog()" title="Open in Google Maps">
            <google-map width="100%" height="100%"
                [mapId]="'yaldi-map-api'"
                [center]="{ lat: telemetry.position!.latitude, lng: telemetry.position!.longitude }"
                [zoom]="14"
                [options]="{ disableDefaultUI: true }"
                (mapInitialized)="onPositionMapReady($event)">
            </google-map>
        </div>
        } @else {
        <span class="info-key">No position data</span>
        }
    </div>

</div>

@defer (when endLocationDialog; prefetch on idle) {
<app-show-location-dialog [lat]="telemetry.position?.latitude ?? 0"
    [lng]="telemetry.position?.longitude ?? 0" [zoom]="17" [(visibility)]="endLocationDialog" />
}